import { mediaCards } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-8">
          热门推荐
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaCards.slice(0, 3).map((card, i) => (
            <div key={i} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-colors duration-300 cursor-pointer">
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2 flex gap-1.5">
                  {card.hot && (
                    <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs rounded-full font-medium whitespace-nowrap">
                      热播
                    </span>
                  )}
                  <span className="px-2 py-0.5 bg-background-950/60 text-background-50 text-xs rounded-full whitespace-nowrap">
                    {card.episode}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-500 text-2xl"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <span className="text-xs text-accent-600 font-medium">{card.category}</span>
                <h3 className="text-sm font-medium text-foreground-800 mt-1 line-clamp-1">{card.title}</h3>
                <p className="text-xs text-foreground-500 mt-1">{card.views} 次观看</p>
              </div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {mediaCards.slice(3, 5).map((card, i) => (
            <div key={i + 3} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-colors duration-300 cursor-pointer">
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-background-950/60 text-background-50 text-xs rounded-full whitespace-nowrap">
                    {card.episode}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-500 text-2xl"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <span className="text-xs text-accent-600 font-medium">{card.category}</span>
                <h3 className="text-sm font-medium text-foreground-800 mt-1 line-clamp-1">{card.title}</h3>
                <p className="text-xs text-foreground-500 mt-1">{card.views} 次观看</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}